import { useState } from "react";
import {
  inboxForTopic,
  queueSupportNote,
  SUPPORT_TOPICS,
} from "@hub";

const EMPTY = { topic: "general", name: "", email: "", message: "", technical: "" };

export default function SupportMailForm() {
  const [form, setForm] = useState(EMPTY);
  const [saved, setSaved] = useState(null);
  const inbox = inboxForTopic(form.topic);

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  function submit(event) {
    event.preventDefault();
    const result = queueSupportNote(form);
    setSaved(result);
    window.location.href = result.mailto;
  }

  if (saved) {
    return (
      <p className="confirm">
        Thank you. Your note is held on this device and addressed to {saved.inbox.email}. If a mail
        window did not open, write us at that address anytime.
      </p>
    );
  }

  return (
    <form className="card" onSubmit={submit} style={{ maxWidth: "36rem" }}>
      <label className="field">
        <span>How can we help?</span>
        <select name="topic" value={form.topic} onChange={update}>
          {SUPPORT_TOPICS.map((topic) => (
            <option key={topic.id} value={topic.id}>
              {topic.label}
            </option>
          ))}
        </select>
      </label>
      <p className="muted">
        This note goes to {inbox.email}. During the Beta Tester Program, replies may take a short
        while — we still read every one.
      </p>
      <label className="field">
        <span>Name</span>
        <input name="name" value={form.name} onChange={update} required />
      </label>
      <label className="field">
        <span>Email</span>
        <input name="email" type="email" value={form.email} onChange={update} required />
      </label>
      <label className="field">
        <span>Your note</span>
        <textarea name="message" rows={5} value={form.message} onChange={update} required />
      </label>
      {inbox.allowTechnical ? (
        <label className="field">
          <span>If something is not working — extra detail (optional)</span>
          <textarea
            name="technical"
            rows={3}
            value={form.technical}
            onChange={update}
            placeholder="What you were doing, and what you hoped would happen."
          />
        </label>
      ) : null}
      <button className="btn" type="submit">
        Send
      </button>
    </form>
  );
}
